import { render, staticRenderFns } from "./ModalProjectUserAdd.vue?vue&type=template&id=5b964d59&lang=pug"
import script from "./ModalProjectUserAdd.vue?vue&type=script&lang=js"
export * from "./ModalProjectUserAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectUserAdd.vue?vue&type=style&index=0&id=5b964d59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports